<template>
  <!--<div>-->
  <div class="mobileBox">
    <!--banner+导航-->
    <div class="topBanner">
      <img class="bannerImg" src="../../../assets/img/partnersBanner_m.png"/>


      <top-nav></top-nav>


    </div>

    <div class="partnersContent" id="m1">
      <div class="animated" :class="animates.mm1 ? 'fadeInUp' : 'hideBox'" >
        <div class="titleBox">Blueshyft</div>
        <div class="textBox">Blueshyft是澳洲第一家将澳洲本地零售场所与线上数字企业结合起来的电子平台企业，现全澳已有1500多个零售点使用。 我们为零售点配备了基于iOS系统的Blueshyft技术平台，具有与客户端系统的实时API连接。 通过快速集成，客户可以通过网络快速销售数字产品.</div>
        <div class="titleBox">Futura Retail Solutions</div>
        <div class="textBox">Futura专注于为澳大利亚时尚、专卖和日常用品零售商设计销售点与库存管理软件。40多年来，Futura4Retail凭借多种POS、商品、库存和端对端零售软件，为零售商提供助力.</div>
        <div class="titleBox">IPOS</div>
        <div class="textBox">IPOS致力于为零售和酒店企业提供量身定制的收银系统和卓越的客户服务，帮助创造业务增长。自成立以来，已有超过2000名忠实客户加入，他们是澳大利亚主要首府城市最受欢迎的POS系统供应商之一.</div>
        <div class="titleBox">银豹 PosPal</div>
        <div class="textBox">银豹收银系统（PosPal）是由准动网络科技（厦门）有限公司（简称准动）独立开发的新一代收银软件。采用云端技术，是国内稳定的云架构收银软件之一，也是业内较早实现与移动互联网实时对接的收银系统之一。超强的兼容性跨平台支持多数主流设备，集成多种支付方式满足不同用户需求.</div>
        <!-- <div class="titleBox">华钦科技 CLPS</div>
        <div class="textBox">作为全球信息技术咨询和解决方案服务提供商，华钦科技专注于向中国及全球银行、保险和金融领域机构提供服务.</div> -->
        <div class="titleBox">琼景科技 Grand View Technology</div>
        <div class="textBox">深圳琼景科技有限公司（GVT），专注于澳中跨境贸易服务，是一家专业的澳中跨境S2B平台。 GVT通过旗下澳中跨境全链路一站式供销系统“Astraea阿斯米亚”，为澳洲的品牌商、厂家、渠道商和中国的卖家、第三方平台、分销商、终端消费者提供跨境交易的SaaS服务，实现从澳洲源头商家到中国消费者的全链路深度融合和高效对接，形成S2B2C的跨境云供应链生态圈.</div>
      </div>
    </div>

    <!--底部-->
    <div class="footer_m ">
      <div class="footer_mText">
        Supay Technology Pty Ltd. Authorized Representative Number 001283947
        <div class="goTopBtn" @click="toTop"><img src="../../../assets/icon/goTopIcon.png"/></div>
      </div>
    </div>

  </div>
  <!--</div>-->
</template>

<script>
  import topNav from './nav_m'
  let timer = null; //定义初始值
  export default {
    name: "Partners_m",
    components:{topNav},
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:50
      }
    },
    data() {
      return {
        animates:{
          mm1:false,
        },
      }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
    },
    mounted () {
      document.documentElement.scrollTop=0;

      this.animates.mm1 = true;
    },
    methods:{


      //置顶
      toTop(){ // 动画

        timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          // this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    }
  }
</script>

<style scoped>
  .mobileBox{width: 100%;height: auto;}
  .mobileBox .topBanner{width: 100%;height: auto;position: relative;}
  .mobileBox .topBanner .bannerImg{width: 100%;height: auto;}

  .partnersMain{width: 100%;height: auto;}
  .partnersMain .bannerBox{width: 100%;height: auto;position: relative;}
  .partnersMain .bannerBox>img{width: 100%;}
  .partnersMain .bannerBox .topTextBox{width: 100%;height: 100%;position: absolute;top: 0;left: 0;}
  .partnersMain .bannerBox .topTextBox .bannerText1{height: 7rem;text-align: center;margin-top: 12%;}
  .partnersMain .bannerBox .topTextBox .bannerText1>img{width: 14rem;}


  /*内容部分*/
  .partnersContent{width: 100%;height: auto;padding: 0.2rem 0 3rem 0;background-color: #fff;}
  .partnersContent .titleBox{width: 90%;margin: 3rem auto 1rem auto; line-height: 2rem;font-family: OpenSans300;color: #000;font-size: 1.3rem;}
  .partnersContent .textBox{width: 90%;margin: 1rem auto;line-height: 1.5rem;padding: 1rem 0;font-family: MontserratRegular;color: #4a4a4a;font-size: 0.875rem;}

  .hideBox{display: none;}

</style>
